import React, { HTMLAttributes } from 'react'

import classNames from 'classnames'

const PREFIX = 'nf'

interface Props extends HTMLAttributes<HTMLElement> {
  icon: string
  className?: string
}

const NFIcon: React.FC<Props> = ({ icon, className, ...rest }: Props) => {
  const iconName = normalizeIcon(icon)
  return <i {...rest} className={classNames('nf-icon', iconName, className)} />
}

export default NFIcon

function normalizeIcon(icon: string): string {
  if (icon.startsWith(`${PREFIX}-`)) return icon
  return `${PREFIX}-${icon}`
}
